"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStencilCreatable = void 0;
const restrictLiveVideosToEn = {
    action: 'affect-only-these-stencils',
    stencils: ['live-video'],
    restrictingLocales: ['en'],
};
const restrictAvailableStencilsInRedbullComAdditionalLocales = {
    action: 'allow-only-these-stencils',
    stencils: [
        'event-profile',
        'event-details',
        'image',
    ],
    applyActionInSpaces: ['redbull_com'],
    applyActionInLocales: [
        'en-MT',
        'he-IL',
        'is-IS',
        'ru-UZ',
        'sr-ME',
    ],
};
const restrictAvailableStencilsInKaGElLocale = {
    action: 'allow-only-these-stencils',
    stencils: [
        'event-profile',
        'event-details',
        'image',
        'partner-profile',
    ],
    applyActionInSpaces: ['redbull_com'],
    applyActionInLocales: ['ka-GE'],
};
const restrictAthletesInRedbullCom = {
    action: 'affect-only-these-stencils',
    stencils: ['athlete'],
    applyActionInSpaces: ['redbull_com'],
    restrictingLocaleAccess: ['en'],
    restrictingUserRoles: ['taxonomy-manager'],
};
const restrictArtistsAndShowsInRedbullCom = {
    action: 'affect-only-these-stencils',
    stencils: ['artist', 'show'],
    applyActionInSpaces: ['redbull_com'],
    restrictingUserRoles: ['taxonomy-manager'],
};
const restrictStencilsInCartoonsForTaxonomyManagers = {
    action: 'affect-only-these-stencils',
    stencils: [
        'occasion',
        'collection',
        'tv-commercial',
    ],
    applyActionInSpaces: ['cartoons'],
    restrictingUserRoles: ['taxonomy-manager'],
};
const assetCreationCustomizations = [
    restrictLiveVideosToEn,
    restrictAvailableStencilsInRedbullComAdditionalLocales,
    restrictAthletesInRedbullCom,
    restrictArtistsAndShowsInRedbullCom,
    restrictAvailableStencilsInKaGElLocale,
    restrictStencilsInCartoonsForTaxonomyManagers,
];
const machtesAllRestrictions = (customization, config) => {
    const matchRestrictingSpaces = !customization.restrictingSpaces
        || config.space
            && customization.restrictingSpaces.includes(config.space);
    const matchRestrictingLocales = !customization.restrictingLocales
        || config.locale
            && customization.restrictingLocales.includes(config.locale);
    const matchRestrictingLocaleAccess = !customization.restrictingLocaleAccess
        || config.user?.localizations
            && customization.restrictingLocaleAccess.every((locale) => config.user?.localizations?.includes(locale));
    const matchRestrictingUserRoles = !customization.restrictingUserRoles
        || config.user?.roles
            && customization.restrictingUserRoles.every((locale) => config.user?.roles?.includes(locale));
    return Boolean(matchRestrictingSpaces
        && matchRestrictingLocales
        && matchRestrictingLocaleAccess
        && matchRestrictingUserRoles);
};
const isAffectedForCustomization = (config, customization) => {
    const isAffectedSpace = !customization.applyActionInSpaces || config.space && customization.applyActionInSpaces.includes(config.space);
    const isAffectedLocale = !customization.applyActionInLocales || config.locale && customization.applyActionInLocales.includes(config.locale);
    return Boolean(isAffectedSpace && isAffectedLocale);
};
const isStencilCreatable = (stencil, config) => {
    if (!config) {
        return true;
    }
    return assetCreationCustomizations.every((customization) => {
        if (!isAffectedForCustomization(config, customization)) {
            return true;
        }
        if (customization.action === 'affect-only-these-stencils') {
            return !customization.stencils.includes(stencil.name) || machtesAllRestrictions(customization, config);
        }
        return customization.stencils.includes(stencil.name);
    });
};
exports.isStencilCreatable = isStencilCreatable;
//# sourceMappingURL=data:application/json;base64,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